<script>
  export let app = '';
  export let bgDark = false;
  export let first = false;
  export let inverse = false;
  export let desktopImg = false;
  export let centeredImg = false;
</script>

<section
  class={`
  flex items-center overflow-x-hidden flex-col md2:flex-row text-center md2:text-left
  py-[56px] sm:py-[88px] md:py-[120px] md2:py-[72px] lg:py-[88px] xl:py-[136px]
  gap-[32px] sm:gap-[48px] md:gap-[64px]
  ${first ? 'pt-[16px] sm:pt-[24px] md:pt-[40px] md2:pt-[16px] lg:pt-[32px] xl:pt-[48px]' : ''}
  ${bgDark ? app + '-bg-dark' : ''}
  ${
    centeredImg
      ? 'flex-wrap justify-start mx-auto w-[322px] xs:w-[326px] sm:w-[408px] md:w-[436px] md2:w-[880px] lg:w-[960px] xl:w-[1248px] md2:gap-[72px] lg:gap-[88px] xl:gap-[136px]'
      : 'justify-center md2:gap-[48px] lg:gap-[80px] xl:gap-[86px]'
  } ${desktopImg ? 'md2:justify-between' : ''}`}
>
  <div
    class={`${
      desktopImg ? 'md2:ml-[12.5%]' : ''
    } max-w-[262px] xs:max-w-[266px] sm:max-w-[328px] md:max-w-[356px] md2:max-w-[416px] lg:max-w-[440px] xl:max-w-[578px] w-full
    ${inverse ? 'md2:order-2' : 'md2:order-1'}`}
  >
    <slot name="text" />
    <!-- paragraph with padding top -->
    {#if $$slots.padding}
      <div class="pt-[8px] sm:pt-[16px] md:pt-[24px] md2:pt-[8px] xl:pt-[16px]">
        <slot name="padding" />
      </div>
    {/if}
  </div>
  <div
    class={`
  pointer-events-none select-none flex  lg:min-h-[624px] xl:min-h-[818px]
  ${inverse ? 'md2:order-1' : 'md2:order-2'}
  ${
    desktopImg
      ? 'md2:justify-start h-[370px] min-h-[370px] sm:min-h-[624px] md2:min-h-[528px] xl:min-h-[905px] justify-end w-full'
      : 'justify-center min-h-[536px] w-[322px] xs:w-[326px] sm:w-[388px] md:w-[416px] md2:w-[476px] lg:w-[500px] xl:w-[636px] sm:min-h-[662px] md:min-h-[718px] md2:min-h-[590px]'
  }
  ${centeredImg ? 'no-min-h min-w-[100%]' : ''}
  `}
  >
    <slot name="img" class={`${centeredImg ? '' : 'h-full'}`} />
  </div>
</section>

<style>
  .position-right {
    order: 2;
  }
  .uniapp-bg-dark {
    @apply bg-uniapp-bg-dark;
  }
  .wellabe-bg-dark {
    @apply bg-wellabe-bg-dark;
  }

  .md-integrations-bg-dark {
    @apply bg-md-integrations-bg-dark;
  }

  .fprj-bg-dark {
    @apply bg-fprj-bg-dark;
  }

  .no-min-h {
    min-height: unset !important;
  }
</style>
